import { createRoot } from 'react-dom/client'
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from "@/store";
import { Routes } from "@generouted/react-router";
import './locales';
import "@unocss/reset/tailwind.css";
import "virtual:uno.css";
import "@/assets/css/style.css";

createRoot(document.getElementById("root") as HTMLElement).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Routes />
    </PersistGate>
  </Provider>
);
